import styled from 'styled-components';

export const ThresholdReachMessageParagraph = styled.p`
    font-weight: bold;
    margin-bottom: 10px;
`;



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/PaymentAreaComponentStyle.js